// Promise timeout utility to surface stalled requests
export async function withTimeout<T>(
  promise: PromiseLike<T>,
  ms: number,
  context: string
): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  const timeout = new Promise<never>((_, reject) => {
    timer = setTimeout(() => {
      reject(new Error(`Timeout after ${ms}ms: ${context}`));
    }, ms);
  });
  try {
    const result = await Promise.race([promise as Promise<T>, timeout]);
    return result;
  } finally {
    clearTimeout(timer);
  }
}
